import { PRICE_POLICIES_CLEAN_ROLES_BONIFICATIONS } from '../constants'

export function reducer(state, action) {
    if (action.type === PRICE_POLICIES_CLEAN_ROLES_BONIFICATIONS) {
        return {
            ...state,
            roleBonificationSuccess: false,
            roleBonificationError: false,
            userRolesError: false
        }
    } else {
        return state
    }
}
